export default "__VITE_ASSET__Bq5g3GPy__"